import { execOnLoad, getA11yTranslations, getCssVariable } from '@general/helpers';
import throttle from 'lodash/throttle';
import Swiper from 'swiper';
import { A11y, Navigation, Scrollbar } from 'swiper/modules';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initCarousel = (context) => {
  const snippetContainer = context.classList.contains('carousel__container')
    ? context
    : context.closest('.carousel__container');
  if (!snippetContainer) return;

  const sliderWrapper = snippetContainer.querySelector('.carousel__slider-wrapper');
  const slides = snippetContainer.querySelectorAll('.swiper-slide');
  if (!sliderWrapper || slides.length <= 1) return;

  let leftArrow = snippetContainer.querySelector('.carousel__arrow--left');
  let rightArrow = snippetContainer.querySelector('.carousel__arrow--right');
  let scrollbar = snippetContainer.querySelector('.carousel__scrollbar');

  // Arrows can be rendered in a `.carousel__controls` block that sits OUTSIDE the
  // container (as a sibling) so the container's `overflow: hidden` doesn't clip them.
  const controls = snippetContainer.parentElement?.querySelector(':scope > .carousel__controls');
  if (controls) {
    if (!leftArrow) leftArrow = controls.querySelector('.carousel__arrow--left');
    if (!rightArrow) rightArrow = controls.querySelector('.carousel__arrow--right');
  }

  // Legacy fallback: arrows/scrollbar living in an ancestor carousel container.
  if (!leftArrow || !rightArrow || !scrollbar) {
    const parentGenericContainer = snippetContainer.parentElement?.closest('[class*=carousel__container]');
    if (!leftArrow) leftArrow = parentGenericContainer?.querySelector('.carousel__arrow--left');
    if (!rightArrow) rightArrow = parentGenericContainer?.querySelector('.carousel__arrow--right');
    if (!scrollbar) scrollbar = parentGenericContainer?.querySelector('.carousel__scrollbar');
  }

  const options = {
    modules: [
      ...(window.dAgency.translations ? [A11y] : []),
      ...(leftArrow && rightArrow ? [Navigation] : []),
      ...(scrollbar ? [Scrollbar] : []),
    ],
    ...(scrollbar ? { scrollbar: { el: scrollbar, draggable: true } } : {}),
    ...(leftArrow && rightArrow ? { navigation: { prevEl: leftArrow, nextEl: rightArrow } } : {}),
    ...getA11yTranslations(),
  };
  var swiper;

  const handleSwiper = throttle(() => {
    if (swiper?.destroy) swiper.destroy(true, true);
    swiper = new Swiper(sliderWrapper, {
      ...options,
      slidesPerView: getCssVariable(snippetContainer, '--slides'),
      spaceBetween: getCssVariable(snippetContainer, '--gap'),
    });
  }, 300);

  handleSwiper();
  window.addEventListener('resize', handleSwiper);
};

execOnLoad(window.dAgency.initCarousel, '.carousel__container');
